<template src="@/templates/dashboard/recruitmentDashboard.html"></template>

<script>
    import JobsChart from '@/components/dashboard/charts/Jobs'
    import JobsCollection from "@/collections/jobsCollection";
    import InterpreterCollection from "../../collections/interpreterCollection";
    import moment from 'moment'

    export default {
        name: "RecruitmentDashboard",
        components: {
            JobsChart
        },
        data() {
            return {
                title: "",
                JobsCollection: new JobsCollection,
                interpreterCollection: new InterpreterCollection,
                showSpinner: true,
                recruitedByLanguageChartValues: [],
                recruitedByLanguageLegendName: [],
                recruitedByLanguageText: 'Recruited by Language',
                recruitedByStateChartValues: [],
                recruitedByStateLegendName: [],
                recruitedByStateText: 'Recruited by State',
                recruitedByNaatiTranslatorChartValues: [],
                recruitedByNaatiTranslatorLegendName: [],
                recruitedByNaatiTranslatorText: 'NAATI Translator Certification Category',
                recruitedByNaatiInterpreterChartValues: [],
                recruitedByNaatiInterpreterLegendName: [],
                recruitedByNaatiInterpreterText: 'NAATI Interpreter Certification Category',
                recruitedByGenderChartValues: [],
                recruitedByGenderLegendName: [],
                recruitedByGenderText: 'Recruited by Gender',
                recruitedByDateChartValues: [],
                recruitedByDateLegendName: [],
                recruitedByDateText: 'Recruited by Date'

            }
        },
        created() {
            this.getRecruitmentInfo();
            this.title = 'Recruitment data from 01 Jul ' + this.financialYear('Start') + ' to ' + '30 Jun ' + this.financialYear('End');
        },
        methods: {
            linkToOutstandingInvoicesReport() {
                this.$router.push('/OutstandingInvoices');
            },
            linkToJobsReport(reportFor) {
                this.$router.push({name: "reportJobs", query: {reportFor: reportFor}});
            },
            getRecruitmentInfo() {

                let url = this.$localApiURL + this.interpreterCollection.getRoute('getRecruitmentInfo') + "?&token=" + localStorage.getItem('jwt');
                this.$http.get(url).then((response) => {

                    if (response.data !== null && response.data !== {}) {
                        this.interpreterCollection.models = response.data.data;
                        this.setInterpretersByState();
                        this.setInterpretersByDate();
                        this.setInterpretersByLanguage();
                        this.setInterpretersByGender();
                        this.setInterpretersByNaatiInterpreting();
                        this.setInterpretersByNaatiTranslation();

                    } else {
                        this.interpreterCollection.models = [];
                    }
                    this.showSpinner = false;
                }).catch((error) => {
                    console.error(error);
                });
            },
            setInterpretersByState() {
                let byStateCV = Object.values(this.interpreterCollection.models.byState);
                let byStateLN = Object.values(Object.keys(this.interpreterCollection.models.byState));
                byStateCV.forEach((item) => {
                    this.recruitedByStateChartValues.unshift([item]);
                });

                byStateLN.forEach((item) => {
                    this.recruitedByStateLegendName.unshift([item]);
                });
            },
            setInterpretersByDate() {
                let byDateCV = Object.values(this.interpreterCollection.models.byDate);
                let byDateLN = Object.values(Object.keys(this.interpreterCollection.models.byDate));
                byDateCV.forEach((item) => {
                    this.recruitedByDateChartValues.unshift([item]);
                });

                byDateLN.forEach((item) => {
                    this.recruitedByDateLegendName.unshift([item]);
                });
            },
            setInterpretersByLanguage() {
                let languagesCV = Object.values(this.interpreterCollection.models.byLanguage);
                let languagesLN = Object.values(Object.keys(this.interpreterCollection.models.byLanguage));

                languagesCV.forEach((item) => {
                    this.recruitedByLanguageChartValues.unshift([item]);
                });

                languagesLN.forEach((item) => {
                    this.recruitedByLanguageLegendName.unshift([item]);
                });
            },
            setInterpretersByGender() {
                this.recruitedByGenderChartValues = Object.values(this.interpreterCollection.models.byGender);
                this.recruitedByGenderLegendName = Object.values(Object.keys(this.interpreterCollection.models.byGender));
            },
            setInterpretersByNaatiInterpreting() {

                if (this.interpreterCollection.models.byNaatiLevel == null)
                    return;
                if (this.interpreterCollection.models.byNaatiLevel["Interpreting"] == null)
                    return;

                let interpreting = this.interpreterCollection.models.byNaatiLevel["Interpreting"];

                let interpretingCV = [];
                let interpretingLN = [];


                interpretingCV = Object.values(interpreting);
                interpretingLN = Object.values(interpreting);


                interpretingCV.forEach((interpretingValues) => {
                    let itemValues = Object.values(interpretingValues);
                    itemValues.forEach((item) => {
                        this.recruitedByNaatiInterpreterChartValues.unshift([item]);
                    });
                });

                interpretingLN.forEach((interpretingValues) => {
                    let itemKeys = Object.keys(interpretingValues);
                    itemKeys.forEach((item) => {
                        this.recruitedByNaatiInterpreterLegendName.unshift([item]);
                    });
                });
            },
            setInterpretersByNaatiTranslation() {

                if (this.interpreterCollection.models.byNaatiLevel == null)
                    return;

                let byNaatiLevel = this.interpreterCollection.models.byNaatiLevel;


                let naatiiLevelArray = Object.keys(byNaatiLevel);

                naatiiLevelArray.forEach((translateItem) => {
                    let translator = this.interpreterCollection.models.byNaatiLevel[translateItem];
                    let values = Object.values(translator);
                    if (translateItem === "Translation to English") {
                        let translateItemText = " into English";
                        this.extractTranslateInfo(translateItemText, values);

                    } else if (translateItem === "Translation from English") {
                        let translateItemText = " into LOTE";
                        this.extractTranslateInfo(translateItemText, values);
                    }
                });
            }, extractTranslateInfo(translateItem, values) {
                values.forEach((interpretingValues) => {
                    let itemValues = Object.values(interpretingValues);
                    itemValues.forEach((item) => {
                        this.recruitedByNaatiTranslatorChartValues.unshift([item]);
                    });
                    let itemKeys = Object.keys(interpretingValues);
                    itemKeys.forEach((item) => {

                        let translateItemLabel = item + translateItem;
                        this.recruitedByNaatiTranslatorLegendName.unshift([translateItemLabel]);
                    });
                });
            },
            financialYear(identifier) {

	            let month = parseInt(moment().format("M"));
	            let year = parseInt(moment().format("Y"));

                if (month < 7) {
                    if (identifier === 'Start') {
                        return year - 1;
                    }
                    else {
                        return year;
                    }
                }

                if (month < 13) {
                    if (identifier === 'Start') {
                        return year;
                    }
                    else {
                        return year + 1;
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/RecruitmentDashboardComponent.vue